import { addDays, isAfter, isBefore, isSameDay, startOfDay } from 'date-fns';

export const augmentDay = (
  direction: 'next' | 'previous',
  date: Date | null
) => {
  const numberOfDays = direction === 'next' ? 1 : -1;

  if (!date) {
    return null;
  }

  return addDays(date, numberOfDays);
};

export const determineIsInDateRange = (
  date: Date,
  maxDate?: Date,
  minDate?: Date
) => {
  const startOfMaxDate = maxDate && startOfDay(maxDate);
  const startOfMinDate = minDate && startOfDay(minDate);

  const isBeforeMaxDate = startOfMaxDate
    ? isBefore(date, startOfMaxDate) || isSameDay(date, startOfMaxDate)
    : true;

  const isAfterMinDate = startOfMinDate
    ? isAfter(date, startOfMinDate) || isSameDay(date, startOfMinDate)
    : true;

  return isAfterMinDate && isBeforeMaxDate;
};
